import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { OCarouselGalleryHero as OCarouselGalleryHeroComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

export const OCarouselGalleryHeroConfig = {
  emptyLabel: 'OCarouselGalleryHero',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-carousel-gallery-hero`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OCarouselGalleryHero = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div
      data-testid="o-carousel-gallery-hero-comp"
      data-component-name="o-carousel-gallery-hero"
      id={componentId}
      className={clsx(styleclass, 'm-container-fullbleed')}
    >
      <EditableComponent config={OCarouselGalleryHeroConfig} {...props}>
        <OCarouselGalleryHeroComp {...props} />
      </EditableComponent>
    </div>
  );
};
